import { Injectable } from '@angular/core';
import { createState, Store, withProps } from '@ngneat/elf';
import {
  localStorageStrategy, persistState
} from '@ngneat/elf-persist-state';

export interface AppProps {
  db_created: boolean
  downloaded_data: boolean
}

const { state, config } = createState(withProps<AppProps>({
  db_created: false,
  downloaded_data: false
}));

const appStore = new Store({ state, name: 'app', config });

export const persist = persistState(appStore, {
  key: 'app',
  storage: localStorageStrategy,
});

@Injectable({ providedIn: 'root' })
export class AppRepository {

  getState() {
    return appStore.getValue();
  }

  updateState(state: AppProps) {
    appStore.update(() => (state))
  }

  reset() {
    appStore.reset()
  }
}
